import Model from "~/models/_Model";
import ComparisonScoreScore from "./ComparisonScoreScore";
import ComparisonScoreComment from "./ComparisonScoreComment";

export default class ComparisonScore extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "comparisons/scores";
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get as_student_scores() {
    const item = new ComparisonScoreScore(this);
    item.results = this.results[0].student_scores;
    return item;
  }
  get as_student_asmt_comments() {
    const item = new ComparisonScoreComment(this);
    item.results = this.results[0].student_asmt_comments;
    return item;
  }
  /*
  getScoreResultCount(resultType = null) {
    if (resultType) {
      return this.results[0].student_scores[resultType].length;
    }
    let count = 0;
    Object.values(this.results[0].student_scores).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }

  getCommentResultCount(resultType = null) {
    if (resultType) {
      return this.results[0].student_asmt_comments[resultType].length;
    }
    let count = 0;
    Object.values(this.results[0].student_asmt_comments).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
  */
}
